import { find, isNil, map } from 'lodash';

import type { SocialInboxMessage } from '@/components/pages/conversations/SocialInbox/types';

class SocialInboxService {
    updateMessagesInDataSource = (
        previousData: any[],
        updatedMessages: SocialInboxMessage[],
        dataKey: string
    ) => {
        return map(previousData, (page) => {
            if (isNil(page[dataKey])) {
                return page;
            }

            return {
                ...page,
                [dataKey]: map(page[dataKey], (msg: SocialInboxMessage) => {
                    const updatedItem = find(updatedMessages, (item) => item.id === msg.id);
                    return updatedItem ? { ...msg, ...updatedItem } : msg;
                })
            };
        });
    };
}

const socialInboxService = new SocialInboxService();

export { socialInboxService as SocialInboxService };
